import button from 'assets/scss/_button.module.scss';
import style from 'assets/scss/donate.module.scss';

export default function Donate({scrollToDonate}) {
    return (
        <section id="donate" ref={scrollToDonate}>
            <div className={`bg-[#242f6f] p-5 pb-0`}>
                <div className="container block mx-auto h-full">
                    <div className="grid md:grid-cols-2 gap-16 h-full">
                        <div className="__imgWrapper">
                            <img src="/assets/img/_3.png" alt="" />
                        </div>
                        <div className={`${style.__content} flex align-center justify-center flex-col`}>
                            <div className="block mb-10 relative">
                                <div className="flex items-end flex-col justify-end gap-4">
                                    <div className="text-2xl text-yellow font-light font-mm leading-none">All in all, the goal of my planning and doing is to find the true meaning in life: peace of mind.</div>
                                    <div className="text-2xl text-yellow font-light font-mm leading-none">- Bruce Lee</div>
                                </div>
                            </div>
                            <div className="block mb-7">
                                <div className="flex items-end flex-col justify-end gap-4">
                                    <p className="text-lg text-white">Bruce Lee’s legacy inspired others more than just martial arts, allowing people to embrace their uniqueness and finding the best versions of themselves, while staying grounded to their culture. We incite positive change in communities with programs and events that will impact our society for the better.</p>
                                    <p className="text-lg text-white">We bring together a community of like-minded individuals to slowly begin to understand themselves and as a result, be more accepting of others.</p>
                                </div>
                            </div>
                            <div className="block mb-5">
                                <div className="flex items-start flex-col justify-end gap-4 rounded-3xl">
                                    <button className={`${button.__redBtn}`}>
                                        <span className='text-xl'> Make a Donation </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}